import App from './App.vue'
import { createApp } from "vue";
import { createPinia } from 'pinia'

import * as VueRouter from 'vue-router';
import ArchivePage from "@/components/ArchivePage";
import SingleCar from "@/components/SingleCar";
import ThankYou from "@/components/ThankYou.vue";
import DropZone from 'dropzone-vue';
import 'dropzone-vue/dist/dropzone-vue.common.css';
import mitt from 'mitt';
import { useCarStore } from './stores/car';  // Adjust the path to point to your car.js file


import { Form, Field, ErrorMessage } from 'vee-validate';
import { configure } from 'vee-validate';
import { localize } from '@vee-validate/i18n';
import nl from '@vee-validate/i18n/dist/locale/nl.json';
import './style.scss'
import 'vue3-carousel/dist/carousel.css';
import { createSlug } from './utils/slugUtils';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faShareNodes } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { faFacebook} from '@fortawesome/free-brands-svg-icons';
import { faXTwitter} from '@fortawesome/free-brands-svg-icons';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
library.add(faShareNodes);
library.add(faEnvelope);
library.add(faCopy);
library.add(faFilePdf);
library.add(faLinkedin);
library.add(faWhatsapp);
library.add(faXTwitter);
library.add(faFacebook);

configure({
    generateMessage: localize({
        nl
    }),
});

// Check for Env
const host = window.location.host;

if (host.indexOf('staging') >= 0) {
    window.appDomain = process.env.VUE_APP_DOMAIN_STAGING
    window.currentApiUri = process.env.VUE_APP_API_URI_STAGING
    window.ctcBuild = process.env.VUE_APP_STAGING_BUILD
}
else {
    window.appDomain = process.env.VUE_APP_DOMAIN_PRODUCTION
    window.currentApiUri = process.env.VUE_APP_API_URI_PROD;
    window.ctcBuild = process.env.VUE_APP_PRODUCTION_BUILD
}
window.slugify = function(str) {
    return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
},

window.getslug = function(car) {
    let type = car.mappeddata.type.replace(/[\W_]+/g,"-")
    let slug = car.mappeddata.slug.replace(/\D/g,"")
    return  window.slugify(car.mappeddata.brand) + '-' + window.slugify(car.mappeddata.model) + '-' + window.slugify(type + '-') + window.slugify(slug);
};
global.jQuery = require('jquery');
var $ = global.jQuery;
window.jq = $;
const emitter = mitt();
// const mountEl = document.querySelector('#crc-shadow').shadowRoot.getElementById("crc-car-component");
const mountEl = document.getElementById("crc-car-component");
window.crcApiUrl = mountEl.getAttribute('data-api')+"vue-endpoint/"+mountEl.getAttribute('data-apikey');
window.crcApiKey = mountEl.getAttribute('data-ctc-apikey');
window.conectApiKey = mountEl.getAttribute('data-apikey');
window.crcBaseApiUrl = mountEl.getAttribute('data-api')

const routes = [
    {
        name: 'Home',
        path: '/',
        component: ArchivePage,
        props: () => ({ ...mountEl.dataset })
    },
    {
        name: 'DetailByModel',
        path: '/:model',
        component: SingleCar,
        props: (route) => ({ ...route.params })
    },
    {
        name: 'Detail',
        path: '/:carid(\\d+)',
        component: SingleCar,
        props: (route) => ({ ...route.params }),
        beforeEnter: (to, from, next) => {
            const carStore = useCarStore();
            const carId = to.params.carid;

            // Make sure the cars data is fetched
            carStore.fetchCars().then(() => {
                // Find the car using carid
                const car = carStore.cars.find(c => c.mappeddata.slug === carId);

                console.log("Found car:", car);

                if (car) {
                    const brandSlug = createSlug(car.mappeddata.brand);
                    const modelSlug = createSlug(car.mappeddata.model);
                    const typeSlug = createSlug(car.mappeddata.type);
                    const detailedSlug = `${brandSlug}-${modelSlug}-${typeSlug}-${carId}`;

                    next(detailedSlug);
                    // Allow the current route to complete, but consider logging or storing the slug for use in the SingleCar component
                } else {
                    console.error("Car not found for carid:", carId);
                    next('/');
                }
            });
        }

    },

    {
        name: 'ThankYou',
        path: '/thankyou/:id',
        component: ThankYou
    }
];

const router = VueRouter.createRouter({
    // history: VueRouter.createWebHashHistory(),
    history: VueRouter.createWebHistory('aanbod'),
    routes,
    scrollBehavior() {
        return { top: 0 }
    },
})
const pinia = createPinia()
const app = createApp(App,{ ...mountEl.dataset });
app.config.globalProperties.emitter = emitter;
app.component('font-awesome-icon', FontAwesomeIcon);
// eslint-disable-next-line vue/multi-word-component-names
app.component("Form", Form);
// eslint-disable-next-line vue/multi-word-component-names
app.component("Field", Field);
app.component("ErrorMessage", ErrorMessage);
app.use(pinia)
app.use(router)
app.use(DropZone)


app.mount(mountEl);
